import React from "react";

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "primary" | "secondary" | "outline" | "green" | "red" | "pending";
}

const variantStyles: Record<NonNullable<BadgeProps["variant"]>, string> = {
  primary: "border-[#EF0BB8]/50 bg-[#EF0BB8]/70 text-[#EF0BB8] shadow-sm",
  secondary: "border-[#C2C8D2]/50 bg-[#C2C8D2]/70 text-[#484848] shadow-sm",
  outline: "border border-gray-300 text-gray-800 bg-transparent",
  green: "border-emerald-400/50 bg-emerald-400/40 text-emerald-600 shadow-sm",
  red: "border-[#FF0000]/50 bg-[#FF0000] text-white shadow-sm",
  pending: "border-[#FFA500]/50 bg-[#FFA500]/40 text-[#FFA500] shadow-sm",
};

export function Badge({
  className = "",
  variant = "primary",
  ...props
}: BadgeProps) {
  const baseClasses = "inline-flex items-center rounded-md px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
  const variantClass = variantStyles[variant] || "";
  const finalClassName = `${baseClasses} ${variantClass} ${className}`.trim();

  return <div className={finalClassName} {...props} />;
}
